import React, { useEffect, useState } from 'react'
import Text from '../../components/text/Text'
import './SubscriptionStyle.css'
import check from '../../assets/icons/icons-check.png'
import star from '../../assets/icons/pro-star.png'

import locked from '../../assets/icons/icons-locked.png'
import polygon from '../../assets/icons/icons-polygon.png'
// import { getPlanPrice } from '../../services/amipos'
import { useLoadingContext } from '../../context/spinnerContext'
import { getLocal, getLocalName } from '../../Utils/Profile'
// import paymentButton from '../../assets/icons/payment-method-button.png'
import proTitle from '../../assets/icons/pro-title-image.png'
import standardTitle from '../../assets/icons/standard-title-image.png'
import baseTitle from '../../assets/icons/plan-base-title.png'
import { getPlanDetails } from '../../services/products'
import { getCommerceInfo } from '../../services/commerce'

interface BillingOption {
    label: string
    price: string
    discountPrice: string
}

interface IPlans {
    planId: string
    planName: string
    options: Option[]
    priceOption: BillingOption[]
}

type IBillingOptionWS = {
    price: string
    discount: string
    periodID: number
    dueDate: string
}

type IBillingOptionsWS = {
    [key: string]: IBillingOptionWS
}

type IPlanWS = {
    planName: string
    billingOptions: IBillingOptionsWS
}

type IPlansW = {
    [key: string]: IPlanWS
}

type IBillingOptions = {
    plans: IPlansW
    addons: IPlansW
}

interface PlanDetail {
    moduleName?: string
    moduleDescription?: string
    active?: boolean
    color?: string
    moduleId: number
}
interface Plan {
    id: number
    name: string
    planDetails: PlanDetail[]
}
interface FeatureOption {
    featureId: number
    title: string
    text: string
    active: boolean
    extra?: string
    color?: string
}

export default function SubscriptionScreen() {
    const loadingContext = useLoadingContext()

    const [plans, setPlans] = useState<IPlans[]>()

    const [selectedFeatureIndex, setSelectedFeatureIndex] = useState<number>(0)
    const [planSelected, setPlanSelected] = useState<number>(0)
    const [planSelectedIndexOption, setPlanSelectedIndexOption] =
        useState<number>(0)

    const [featureOptionProTmp, setFeatureOptionProTmp] = useState<
        FeatureOption[]
    >([])

    const [plan, setPlan] = useState<Plan>()
    const planDetails = plan?.planDetails || []

    // useEffect(() => {
    //     loadingContext?.onOpen()

    //     getPlanPrice()
    //         .then((res) => {
    //             if (!res || !res.data) {
    //                 console.warn('No se obtuvo data del API de precios')
    //                 return
    //             }

    //             const data: IBillingOptions = res.data
    //             const transformedPlans = Object.entries(data.plans).map(
    //                 ([key, plan]) => {
    //                     const priceOption = Object.entries(
    //                         plan?.billingOptions
    //                     ).map(([label, options]) => ({
    //                         label: label,
    //                         price: options.price,
    //                         discountPrice: options.discount,
    //                         periodID: options.periodID,
    //                         dueDate: options.dueDate,
    //                     }))
    //                     return {
    //                         planId: key,
    //                         planName: plan?.planName,
    //                         options: priceOption.map((item) => ({
    //                             label: item.label,
    //                             id: item.price,
    //                         })),
    //                         priceOption,
    //                     }
    //                 }
    //             )

    //             if (!transformedPlans || transformedPlans.length === 0) {
    //                 console.warn('No hay planes disponibles')
    //                 return
    //             }

    //             const planOptionsSelectedIndex = transformedPlans.findIndex(
    //                 (item) => {
    //                     console.log('AAAAAWWW', plan?.name, item.planName)
    //                     return plan?.name
    //                         .toUpperCase()
    //                         .includes(item.planName.toUpperCase())
    //                 }
    //             )

    //             const planOptionsSelected =
    //                 transformedPlans[planOptionsSelectedIndex] ||
    //                 transformedPlans[0]

    //             const planOptionIndex = planOptionsSelected?.options.findIndex(
    //                 (item) => item.label === 'Anual'
    //             )

    //             setPlanSelectedIndexOption(planOptionIndex || 0)
    //             setPlanSelected(planOptionsSelectedIndex)
    //             setPlans(transformedPlans)
    //         })
    //         .catch((error) => {
    //             console.error('Error al obtener precios del plan:', error)
    //         })
    //         .finally(() => {
    //             loadingContext?.onClose()
    //         })
    // }, [plan])

    const getPlan = async () => {
        try {
            const currentUser = localStorage.getItem('currentUser')
            const user = currentUser && JSON.parse(currentUser)
            const commerceId = user?.sEstablecimiento + getLocal()
            const commerce = await getCommerceInfo(commerceId)
            console.log('commerce', commerce)
            //TODO CAMBIAR CUANDO LA API DEVUELVA EL ID
            const planId = commerce.plan.toUpperCase().includes('ESTANDAR')
                ? 3
                : commerce.plan.toUpperCase().includes('PRO')
                ? 1
                : 2
            const response = await getPlanDetails(planId)
            console.log('el plan', response)
            setPlan(response)

            const features =
                Array.isArray(response.planDetails) &&
                response.planDetails.length > 0
                    ? response.planDetails
                          .filter(
                              (
                                  item: PlanDetail | undefined
                              ): item is PlanDetail => !!item
                          )
                          .map((item: PlanDetail, index: number) => ({
                              featureId: index + 1,
                              title: item.moduleName ?? 'Sin título',
                              text: item.moduleDescription ?? '',
                              active: item.active ?? false,
                          }))
                    : []

            setFeatureOptionProTmp(features)
            console.log('SE CARGO')
        } catch (err) {
            console.error('Error al cargar los planes.', err)
        } finally {
            setTimeout(() => {
                loadingContext?.onClose()
            }, 1000)
        }
    }

    useEffect(() => {
        loadingContext?.onOpen()
        getPlan()
    }, [])

    if (!plan) return <div />

    return (
        <div>
            <div
                className={
                    plan?.id === 1
                        ? 'background-banner'
                        : 'background-banner-standard'
                }
            >
                <div className="banner-text-container">
                    <Text
                        label={'Mi plan'}
                        fontSize={24}
                        fontWeight={600}
                        color={'white'}
                        marginLeft={30}
                        fontFamily="Poppins"
                    />

                    <div style={{ marginLeft: 30 }}>
                        {plan?.id === 1 && (
                            <img src={proTitle} height={70} width={130} />
                        )}
                        {plan?.id === 3 && (
                            <img src={standardTitle} height={77} />
                        )}
                        {plan?.id === 2 && <img src={baseTitle} height={77} />}
                    </div>

                    {/* <Text
                        label={'Medio de pago vinculado a suscripción'}
                        fontSize={14}
                        fontWeight={400}
                        color={'white'}
                        marginLeft={30}
                        fontFamily="Poppins"
                        marginTop={10}
                        marginBottom={2}
                    />
                    <div style={{ marginLeft: 30, marginTop: 10 }}>
                        <img src={paymentButton} height={50} width={233} />
                    </div> */}
                </div>
            </div>
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginTop: 20,
                    justifyContent: 'space-between',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                    }}
                >
                    <Text
                        label="LOCAL: "
                        fontSize={24}
                        marginBottom={10}
                        fontWeight={400}
                        lineHeight={1}
                        color="#2699D6"
                        fontFamily={'Poppins'}
                    />
                    <Text
                        label={getLocalName()}
                        fontSize={24}
                        marginBottom={10}
                        fontWeight={700}
                        lineHeight={1}
                        color="#2699D6"
                        style={{ marginLeft: 8 }}
                        fontFamily={'Poppins'}
                    />
                </div>
                {/*  <div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                        }}
                    >
                        <Text
                            label="Valor: "
                            fontSize={14}
                            marginBottom={10}
                            fontWeight={400}
                            lineHeight={1}
                            color="#2699D6"
                        />
                        <Text
                            label="$XX.XXX/año"
                            fontSize={14}
                            marginBottom={10}
                            fontWeight={700}
                            lineHeight={1}
                            color="#2699D6"
                        />
                    </div>
                    <div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                            }}
                        >
                            <Text
                                label="Próximo cobro: "
                                fontSize={14}
                                marginBottom={10}
                                fontWeight={400}
                                lineHeight={1}
                                color="#2699D6"
                            />
                            <Text
                                label="agosto 02, 2024"
                                fontSize={14}
                                marginBottom={10}
                                fontWeight={700}
                                lineHeight={1}
                                color="#2699D6"
                            />
                        </div>
                    </div>
                </div> */}
            </div>
            <Text
                label="Funciones disponibles:"
                fontSize={14}
                fontWeight={400}
                color={'#656565'}
                marginTop={30}
                fontFamily={'Poppins'}
            />

            <div className="feature-option-container">
                {plan?.planDetails?.map((item, indx) => (
                    <div
                        key={`${item.moduleName}`}
                        className="feature-option-item"
                    >
                        <div
                            className="flex-direction-row-subscription"
                            onClick={() => {
                                setSelectedFeatureIndex(indx)
                            }}
                        >
                            <img
                                src={
                                    plan?.id === 1 && item.moduleId === 9
                                        ? star
                                        : item.active
                                        ? check
                                        : locked
                                }
                                className="check-icon"
                            />
                            <Text
                                label={item.moduleName}
                                fontSize={16}
                                fontWeight={600}
                                color={
                                    plan?.id === 1 && item.moduleId === 9
                                        ? '#62B565'
                                        : item.color
                                        ? `#${item.color}`
                                        : '#2699D6'
                                }
                                marginLeft={10}
                                marginTop={15}
                                fontFamily="Poppins"
                                style={indx === 8 ? { width: '30%' } : {}}
                            />
                            <Text
                                label={
                                    selectedFeatureIndex === indx
                                        ? 'ver menos'
                                        : 'ver más'
                                }
                                marginTop={15}
                                fontSize={11}
                                marginLeft={10}
                                fontWeight={600}
                                color={'#565656'}
                                fontFamily="Poppins"
                            />
                            <img src={polygon} className="polygon-icon" />
                        </div>
                        {selectedFeatureIndex === indx && (
                            <div className="subscription-feature-text">
                                <Text
                                    label={item.moduleDescription}
                                    fontSize={14}
                                    fontWeight={400}
                                    color={'#656565'}
                                    fontFamily="Poppins"
                                />
                            </div>
                        )}
                        <div className="subscription-line" />
                    </div>
                ))}
            </div>
            {/*    <Text
                label={'Tus complementos'}
                fontSize={27}
                fontWeight={400}
                color={'#184287'}
                fontFamily="Poppins"
            /> */}
        </div>
    )
}
